<template>
  <article class="carousel-card">
    <slot />
  </article>
</template>

<script>
  export default {
    name: 'CarouselCard',
  };
</script>

<style lang="scss" scoped>
  .carousel-card {
    width: 100%;
    height: 100%;
    scroll-snap-align: start;
  }
</style>
